export { default } from './ResumeRev';
